import { render, staticRenderFns } from "./ChartjsLineAreaChart.vue?vue&type=template&id=7636ed66"
import script from "./ChartjsLineAreaChart.vue?vue&type=script&lang=js"
export * from "./ChartjsLineAreaChart.vue?vue&type=script&lang=js"
import style0 from "./ChartjsLineAreaChart.vue?vue&type=style&index=0&id=7636ed66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports